import {
  UserLoginModel,
  UserInfoModel,
  UserLogoutModel
} from 'src/model/index'
import {
  extend
} from 'lodash'


const user = {
  getters: {
    getUserInfo: (state) => state
  },
  state: extend({
    id: '',
    mobile: '',
    nick_name: '',
    user_name: '',
    organization: {},
    avatar: '',
    sex: '',
    status: '',
    roles: [],
    code: '',
    _state: '',
    introduction: '',
    setting: {
      articlePlatform: []
    }
  }),

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_USER_INFO: (state, userInfo) => {
      extend(state, userInfo);
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      return UserLoginModel.getInstance().execute(userInfo).then((response) => {
        commit('SET_USER_INFO', {
          id: undefined,
          _state: ''
        });
        return response;
      });
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return UserInfoModel.getInstance().execute().then((response) => {
        commit('SET_USER_INFO', extend({
          _state: 'success'
        }, response));
        return response;
      }).catch((err)=>{
        commit('SET_USER_INFO', {
          _state: 'fetched'
        });
        return Promise.reject(err);
      });
      /*return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            reject('error')
          }
          const data = response.data

          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getInfo: roles must be a non-null array !')
          }

          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })*/
    },

    // 第三方验证登录
    // LoginByThirdparty({ commit, state }, code) {
    //   return new Promise((resolve, reject) => {
    //     commit('SET_CODE', code)
    //     loginByThirdparty(state.status, state.email, state.code).then(response => {
    //       commit('SET_TOKEN', response.data.token)
    //       setToken(response.data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 登出
    LogOut({ commit, state }) {
      return UserLogoutModel
        .getInstance()
        .execute()
        .then(()=>{
          commit('SET_USER_INFO', {
            id: '',
            mobile: '',
            nick_name: '',
            user_name: '',
            organization: {},
            avatar: '',
            sex: '',
            status: '',
            roles: [],
            code: '',
            _state: 'fetched',
          })
        });
    },

    // 前端 登出
    FedLogOut({ commit }, fetchState = false) {
      return new Promise(resolve => {
        commit('SET_USER_INFO', {
          id: '',
          mobile: '',
          nick_name: '',
          user_name: '',
          organization: {},
          avatar: '',
          sex: '',
          status: '',
          roles: [],
          code: '',
          _state: fetchState === false ? 'fetched' : '',
        })
        resolve()
      })
    },

    // 动态修改权限
    /*ChangeRoles({ commit }, role) {
      return new Promise(resolve => {
        setToken(role)
        getUserInfo(role).then(response => {
          const data = response.data
          commit('SET_ROLES', data.roles)
          commit('SET_NAME', data.name)
          commit('SET_AVATAR', data.avatar)
          commit('SET_INTRODUCTION', data.introduction)
          resolve()
        })
      })
    }*/
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js